import { CatchPraise } from "@/components/catchPraise";
import { useNewNavigate } from "@/shared/client";
import { useGetCommon, type SpecialPreviewInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Flex, Grid, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CustomBox, CustomButton, CustomFlex, CustomSpecialNav, CustomTitle } from "./specialPreview.style";

export const SpecialPreview = ({ title }: { title: string }) => {
    const { data } = useGetCommon<SpecialPreviewInfoResponse>({ section: "specials" });
    const [activeIdx, setActiveIdx] = useState<number | undefined>(data?.currentSpecials[0].specialIdx);
    const { onNavigate } = useNewNavigate();
    const { isTablet, isMobile } = MEDIA();
    const { pathname } = useLocation();

    useEffect(() => {
        if (data && data.currentSpecials.length > 0) {
            setActiveIdx(data.currentSpecials[0].specialIdx);
        }
    }, [data]);

    return data ? (
        <Center as="section" position="relative" flexDir="column" rowGap={isTablet ? "24px" : "48px"}>
            <Flex w="100%" flexDir="column" rowGap="32px">
                <CustomTitle as="h3">{title.toUpperCase()}</CustomTitle>
                <Grid templateColumns="repeat(3, 1fr)">
                    {data.currentSpecials.map((special, idx) => (
                        <CustomSpecialNav
                            w="100%"
                            round="none"
                            border="none"
                            key={special.specialIdx}
                            onClick={() => setActiveIdx(special.specialIdx)}
                            index={idx}
                        >
                            {special.catchPraise.main.secondLine}
                        </CustomSpecialNav>
                    ))}
                </Grid>
            </Flex>
            <Box w="100%" h="640px" position="relative">
                {data.currentSpecials.map((special) => (
                    <CustomFlex
                        className={activeIdx === special.specialIdx ? "on" : "off"}
                        pointerEvents={activeIdx !== special.specialIdx ? "none" : "all"}
                        key={special.specialIdx}
                        position="absolute"
                        flexDir={isTablet ? "column" : "row"}
                        w="100%"
                        h="100%"
                        columnGap="0px"
                    >
                        <Box w="100%" h="100%" background={`url(${special.imgUrl}) no-repeat center/cover`}></Box>
                        <CustomBox
                            w="70%"
                            p={isMobile ? "24px" : "48px"}
                            boxSizing="border-box"
                            flexDir="column"
                            rowGap="64px"
                            alignItems="flex-start"
                            pathName={pathname}
                        >
                            <CatchPraise catchPraise={special.catchPraise} isDetail={false} />
                            <CustomButton
                                size="tiny"
                                round="pill"
                                border="none"
                                iconNamed="add"
                                onClick={() => onNavigate({ path: `/specials/${special.specialIdx}` })}
                            >
                                View More
                            </CustomButton>
                        </CustomBox>
                    </CustomFlex>
                ))}
            </Box>
        </Center>
    ) : (
        <Spinner />
    );
};
